import { readAdminDemoStore, writeAdminDemoStore } from "./adminDemoStore";

export function hasDemoField(field: string): boolean {
  return readAdminDemoStore()[field] !== undefined;
}

export function loadDemoAgents<T extends { id: string }>(
  field: string,
  fallback: T[],
): T[] {
  const value = loadDemoField<unknown>(field, null);
  if (!Array.isArray(value)) return fallback;
  const isAgentLike = (item: unknown): item is T =>
    typeof item === "object" && item != null && "id" in item;
  return value.every(isAgentLike) ? (value as T[]) : fallback;
}

export function loadDemoField<T>(field: string, fallback: T): T {
  const value = readAdminDemoStore()[field];
  if (value === undefined) return fallback;
  return value as T;
}

export function removeDemoField(field: string): void {
  const store = readAdminDemoStore();
  delete store[field];
  writeAdminDemoStore(store);
}

export function saveDemoField(field: string, value: unknown): void {
  const store = readAdminDemoStore();
  store[field] = value;
  writeAdminDemoStore(store);
}
